<template>
  <div id="app">
    <Header />
    <div id="content">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  components: { Footer, Header }
};
</script>

<style lang="scss">
@import "assets/reset.css";
@import "assets/_bulma.scss";

#app {
  height: 100%;
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $text;
  background: linear-gradient(
    to bottom,
    rgba($primary, 0.15),
    $light 15%,
    $light
  );
}
#content {
  height: auto;
  min-height: calc(
    100vh - #{$headerHeight + $headerMarginBottom + $footerMarginTop}
  );
}

a {
  font-weight: bold;
  color: $primary;

  &.router-link-exact-active {
    color: $primary;
  }
}
</style>
